import { createTipGorivaPredicate } from "./cjenikPredicates";

export function cjeniksFilter(cjeniks, filterArgs) {
  return cjeniks.filter(createTipGorivaPredicate(filterArgs.tipGoriva));
}
